import _kebabCase from 'lodash/kebabCase'

import ToolRegistry from './ToolsRegistry'

import asyncComponent from '../utils/AsyncComponent'

const ASCIITable = asyncComponent(() => import('../tools/ASCIITable'))
const BarcodeGenerator = asyncComponent(() => import('../tools/BarcodeGenerator'))
const Base64 = asyncComponent(() => import('../tools/Base64'))
const BaseConversion = asyncComponent(() => import('../tools/BaseConversion'))
const CertificateDetails = asyncComponent(() => import('../tools/CertificateDetails'))
const CSRGenerator = asyncComponent(() => import('../tools/CSRGenerator'))
const CountryTable = asyncComponent(() => import('../tools/CountryTable'))
const CronTester = asyncComponent(() => import('../tools/CronTester'))
const CsvVsJson = asyncComponent(() => import('../tools/CsvVsJson'))
const FaviconGenerator = asyncComponent(() => import('../tools/FaviconGenerator'))
const HexViewer = asyncComponent(() => import('../tools/HexViewer'))
const IpAddress = asyncComponent(() => import('../tools/IpAddress'))
const JQRunner = asyncComponent(() => import('../tools/JQRunner'))
const JSONPathTester = asyncComponent(() => import('../tools/JSONPathTester'))
const JSONPrettyPrint = asyncComponent(() => import('../tools/JSONPrettyPrint'))
const JSONWebToken = asyncComponent(() => import('../tools/JSONWebToken'))
const LoremIpsumGenerator = asyncComponent(() => import('../tools/LoremIpsumGenerator'))
const MarkdownPreview = asyncComponent(() => import('../tools/MarkdownPreview'))
const MathExpression = asyncComponent(() => import('../tools/MathExpression'))
const MessageDigest = asyncComponent(() => import('../tools/MessageDigest'))
const MonitorTest = asyncComponent(() => import('../tools/MonitorTest'))
const QueryString = asyncComponent(() => import('../tools/QueryString'))
const QRCodeGenerator = asyncComponent(() => import('../tools/QRCodeGenerator'))
const RandomNumberGenerator = asyncComponent(() => import('../tools/RandomNumberGenerator'))
const RegexTester = asyncComponent(() => import('../tools/RegexTester'))
const RSAKeyPairGenerator = asyncComponent(() => import('../tools/RSAKeyPairGenerator'))
const SelfSignedCertificateGenerator = asyncComponent(() => import('../tools/SelfSignedCertificateGenerator'))
const SpecialKeyTable = asyncComponent(() => import('../tools/SpecialKeyTable'))
const SmppDecoder = asyncComponent(() => import('../tools/SmppDecoder'))
const SQLPrettyPrint = asyncComponent(() => import('../tools/SQLPrettyPrint'))
const TimeZoneTable = asyncComponent(() => import('../tools/TimeZoneTable'))
const Typeset = asyncComponent(() => import('../tools/Typeset'))
const TOTPGenerator = asyncComponent(() => import('../tools/TOTPGenerator'))
const UnescapeString = asyncComponent(() => import('../tools/UnescapeString'))
const UnitConversion = asyncComponent(() => import('../tools/UnitConversion'))
const UNIXEpoch = asyncComponent(() => import('../tools/UNIXEpoch'))
const UUIDGenerator = asyncComponent(() => import('../tools/UUIDGenerator'))
const NetworkUrl = asyncComponent(() => import('../tools/URL'))
const WebAssemblyToText = asyncComponent(() => import('../tools/WebAssemblyToText'))
const XMLPrettyPrint = asyncComponent(() => import('../tools/XMLPrettyPrint'))
const XPathTester = asyncComponent(() => import('../tools/XPathTester'))

class Tools {
    static Names = ToolRegistry
    static MFU = undefined

    static hello() {}

    // FIXME
    static getTool(title) {
        const tools = Tools.getTools()
        let tool
        tools.forEach(t => {
            if (t.title === title) {
                tool = t
            }
        })
        return tool
    }

    static getTools() {
        const tools = [
            {
                title: Tools.Names.ASCIITable,
                async: ASCIITable,
            },
            {
                title: Tools.Names.BaseConversion,
                async: BaseConversion,
            },
            {
                title: Tools.Names.BarcodeGenerator,
                async: BarcodeGenerator,
            },
            {
                title: Tools.Names.Base64,
                async: Base64,
            },
            {
                title: Tools.Names.CertificateDetails,
                async: CertificateDetails,
            },
            {
                title: Tools.Names.CSRGenerator,
                async: CSRGenerator,
            },
            {
                title: Tools.Names.CountryTable,
                async: CountryTable,
            },
            {
                title: Tools.Names.CronTester,
                async: CronTester,
            },
            {
                title: Tools.Names.CsvVsJson,
                async: CsvVsJson,
            },
            {
                title: Tools.Names.FaviconGenerator,
                async: FaviconGenerator,
            },
            {
                title: Tools.Names.IpAddress,
                async: IpAddress,
            },
            {
                title: Tools.Names.HexViewer,
                async: HexViewer,
            },
            {
                title: Tools.Names.JQRunner,
                async: JQRunner,
            },
            {
                title: Tools.Names.JSONPathTester.title,
                async: JSONPathTester,
                link: Tools.Names.JSONPathTester.link,
            },
            {
                title: Tools.Names.JSONPrettyPrint,
                async: JSONPrettyPrint,
            },
            {
                title: Tools.Names.JSONWebToken,
                async: JSONWebToken,
            },
            {
                title: Tools.Names.LoremIpsumGenerator,
                async: LoremIpsumGenerator,
            },
            {
                title: Tools.Names.MarkdownPreview,
                async: MarkdownPreview,
            },
            {
                title: Tools.Names.MathExpression,
                async: MathExpression,
            },
            {
                title: Tools.Names.MessageDigest,
                async: MessageDigest,
            },
            {
                title: Tools.Names.MonitorTest,
                async: MonitorTest,
            },
            {
                title: Tools.Names.QueryString,
                async: QueryString,
            },
            {
                title: Tools.Names.QRCodeGenerator,
                async: QRCodeGenerator,
            },
            {
                title: Tools.Names.RandomNumberGenerator,
                async: RandomNumberGenerator,
            },
            {
                title: Tools.Names.RegexTester,
                async: RegexTester,
            },
            {
                title: Tools.Names.RSAKeyPairGenerator,
                async: RSAKeyPairGenerator,
            },
            {
                title: Tools.Names.SelfSignedCertificateGenerator,
                async: SelfSignedCertificateGenerator,
            },
            {
                title: Tools.Names.SpecialKeyTable,
                async: SpecialKeyTable,
            },
            {
                title: Tools.Names.SmppDecoder,
                async: SmppDecoder,
            },
            {
                title: Tools.Names.SQLPrettyPrint,
                async: SQLPrettyPrint,
            },
            {
                title: Tools.Names.TimeZoneTable,
                async: TimeZoneTable,
            },
            {
                title: Tools.Names.Typeset,
                async: Typeset,
            },
            {
                title: Tools.Names.TOTPGenerator,
                async: TOTPGenerator,
            },
            {
                title: Tools.Names.UnescapeString,
                async: UnescapeString,
            },
            {
                title: Tools.Names.UnitConversion,
                async: UnitConversion,
            },
            {
                title: Tools.Names.UNIXEpoch,
                async: UNIXEpoch,
            },
            {
                title: Tools.Names.UUIDGenerator,
                async: UUIDGenerator,
            },
            {
                title: Tools.Names.URL,
                async: NetworkUrl,
            },
            {
                title: Tools.Names.WebAssemblyToText,
                async: WebAssemblyToText,
            },
            {
                title: Tools.Names.XMLPrettyPrint,
                async: XMLPrettyPrint,
            },
            {
                title: Tools.Names.XPathTester.title,
                async: XPathTester,
                link: Tools.Names.XPathTester.link,
            },
        ]
        tools.forEach(t => {
            if (!t.link) {
                t.link = '/' + _kebabCase(t.title)
            }
        })
        return tools
    }

    static useTool(title) {
        if (Tools.MFU) {
            Tools.MFU.use(title)
        }
    }
    static sortByUsage(titles) {
        if (Tools.MFU) {
            return Tools.MFU.sort(titles)
        }
        return titles
    }
}

export default Tools
